
// app.js
import React, { useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"; // Added Navigate
import { LinkedInCallback } from 'react-linkedin-login-oauth2';

import { useChatbots } from './contexts/ChatbotContext';
import Layout from './components/Layout';
import ChatbotLayout from './components/ChatbotLayout';

// import Sidebar from './components/Sidebar'; // Sidebar is part of Layout
import './App.css';
import './assets/css/bootstrap.min.css';
import './assets/css/app.css';
import './assets/css/custom.css';

// --- Page Imports (all your pages) ---
import MyChatbots from './pages/MyChatbots'; // Corrected import name
import ChatbotCreationSteps from './pages/Steps/ChatbotCreationSteps.js';
import Dashboard from './pages/Dashboard/Dashboard.js';
import AddDocuments from './pages/Documents/AddDocuments';
import Scraper from './pages/WebsiteLinks/Scraper.js';
import WebsiteConfigurations from './pages/WebsiteConfigurations';
// import AudioLanguage from './pages/AudioLanguage/AddAudioLanguage'; // Assuming ListAudioLanguage is used
import ListAudioLanguage from './pages/AudioLanguage/ListAudioLanguage.js';
import ChatHistory from './pages/ChatHistory';
import ChoosePosition from './pages/ChoosePosition';
import AvatarSettings from './pages/AvatarSettings';
import Analytics from './pages/Analytics';
import UserProfile from './pages/UserProfile';
import Test from './pages/Test';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword.js';
import ColorSettings from './pages/ColorSettings';
import ImproveQuestions from './pages/QuestionImprovement/AddImproveQuestions';
import ImproveAnswer from './pages/AnswerImprovement/ImproveAnswer';
import LogoutPage from './pages/LogoutPage';
import Pronoun from './pages/Pronoun/AddPronoun';
import AddSitemap from './pages/Sitemaps/AddSitemap';
import ListUserFeedback from './pages/UserFeedback.js';
import Help from './info-pages/Help.js';
import Support from './info-pages/Support.js';
import Privacy from './info-pages/Privacy.js';
import Terms from './info-pages/Terms.js';
import Billing from './pages/Billing/Billing.js';
import InvoiceHistory from './pages/Billing/InvoiceHistory.js';
import Pricing from './pages/Billing/Pricing.js';
import SubscriptionHistory from './pages/Billing/SubscriptionHistory.js';
import LiveChatbot from './pages/Dashboard/Live.js';
// import LLMSettings from './pages/LLMSettings.js'; // Likely part of ChatbotSettings
import ChatbotSettings from './pages/ChatbotSettings/ChatbotSettings.js';
// import Prompt from './pages/ChatbotSettings/Prompt.js'; // Likely part of ChatbotSettings
import AddImage from './pages/Image/AddImage.js';
import ListMonetize from './pages/Monetize/ListMonetize.js';
import VoiceTranscription from './pages/VoiceRecording/Recording.js';
import KnowledgeData from './pages/Knowledge/Knowledge.js';
import VerifiedEmail from './pages/Verify.js';
import SignUpSteps from './pages/Steps/SignUpSteps.js';
import PaymentSuccess from './pages/Billing/PaymentSuccess.js';
import ResetPasswordPage from './pages/ResetPasswordPage.js';
import ListExceptionLog from './pages/ExceptionLog/ListExceptionLog.js';
import Channels from './pages/Channels/Channels.js';
import WhatsappChannel from './pages/Channels/Whatsapp/WhatsappChannel.js';
import BulkWhatsappSenderChannel from './pages/Channels/Whatsapp/BulkWhatsappSenderChannel.js';
import Connectors from './pages/Connector/Connectors.js';
import GoogleDriveConnector from './pages/Connector/GoogleDrive/GoogleDriveConnector.js';
import OneDriveConnector from './pages/Connector/OneDrive/OneDriveConnector.js';
import SmsBotConnector from './pages/Connector/SmsBotConnector.js';
import InstagramConnector from './pages/Connector/Instagram/InstagramConnector.js';
import ServiceNowConnector from './pages/Connector/ServiceNow/ServiceNowConnector';
import PrayerTimingConnector from './pages/Connector/PrayerTiming/PrayerTimingConnector';


import Campaigns from './pages/Campaigns/Campaigns.js';
import GmailConnector from './pages/Campaigns/Gmail/GmailConnector.js';
import OutlookConnector from './pages/Campaigns/Outlook/OutlookConnector';
import SmsManagement from './pages/Campaigns/Sms/SmsManagement';
import LeadConnector from './pages/Campaigns/Lead/LeadConnector.js';

// SurveyGenie Imports
import SurveyDashboard from './pages/Campaigns/SurveyGenie/SurveyDashboard';
import SurveyBuilder from './pages/Campaigns/SurveyGenie/SurveyBuilder';
import SurveyResponses from './pages/Campaigns/SurveyGenie/SurveyResponses';
import SurveyAnalytics from './pages/Campaigns/SurveyGenie/SurveyAnalytics';
import SurveyDistribution from './pages/Campaigns/SurveyGenie/SurveyDistribution';
import QuestionBank from './pages/Campaigns/SurveyGenie/QuestionBank';
import PanelistManagement from './pages/Campaigns/SurveyGenie/PanelistManagement';
import PublicSurveyForm from './pages/Public/SurveyGenie/PublicSurveyForm.js';
import SurveyEmailWizard from './pages/Campaigns/SurveyGenie/SurveyEmailWizard';
import SurveyTextAnalysis from './pages/Campaigns/SurveyGenie/SurveyTextAnalysis';
import DataCleaningDashboard from './pages/Campaigns/SurveyGenie/DataCleaningDashboard.js';
import CleaningRulesBuilder from './pages/Campaigns/SurveyGenie/CleaningRulesBuilder.js';
import SurveySmsWizard from './pages/Campaigns/SurveyGenie/SurveySmsWizard';
import SurveyDocuments from './pages/Campaigns/SurveyGenie/SurveyDocuments';
import SurveyFAQs from './pages/Campaigns/SurveyGenie/SurveyFAQs';

import Agents from './pages/Agents/Agents.js';
import GoogleCalendarAgents from './pages/Agents/GoogleCalendar/GoogleCalendarAgents.js';
import MySqlAgents from './pages/Agents/MySQL/MySQLAgents.js';
import GmailEmailAgent from './pages/Agents/Gmail/GmailEmailAgent';
import OutlookEmailAgent from './pages/Agents/Outlook/OutlookEmailAgent.js';
import WorkflowList from './pages/Agents/Workflows/WorkflowList.js';
import WorkflowCreate from './pages/Agents/Workflows/WorkflowCreate.js';
import WorkflowRunDashboard from './pages/Agents/Workflows/WorkflowRunDashboard.js';

import LinkedAccounts from './pages/LinkedAccounts/LinkedAccounts.js';

import SummarizationSettings from './pages/SummarizationSettings/SummarizationSettings.js';
import LiveConversation from './pages/LiveConversation/LiveConversation.js';
import WordpressPlugin from './info-pages/WordPressPlugin.js'; // Assuming this is a public page
import MarketplaceSettings from './pages/Marketplace/MarketplaceSettings.js';

import PaymentsPage from './pages/Payments/PaymentsPage.js'
import PublicPaymentPage from './pages/Public/Payment/PublicPaymentPage';
import PaymentSuccessPage from './pages/Public/Payment/PaymentSuccessPage';
import PaymentCancelPage from './pages/Public/Payment/PaymentCancelPage';
import ManageUsers from './pages/Users/ManageUsers';
import ManageRoles from './pages/Roles/ManageRoles';

import SalesforceConnector from './pages/Connector/Salesforce/SalesforceConnector';
import SuggestedQuestionsSettings from './pages/SuggestedQuestions/SuggestedQuestionsSettings.js';
import ProactiveMessagesSettings from './pages/ProactiveMessages/ProactiveMessagesSettings.js';
import TermsManagement from './pages/Terms/TermsManagement.js';

// Event Management and Outreach Campaigns
import VolunteerManagement from './pages/Campaigns/VolunteerManagement/VolunteerManagement.js';
import EventManagement from './pages/Campaigns/VolunteerManagement/EventManagement';
import OutreachCampaignWizard from './pages/Campaigns/VolunteerManagement/OutreachCampaignWizard';
import EventVolunteers from './pages/Campaigns/VolunteerManagement/EventVolunteers';
import PublicAvailabilityForm from './pages/Public/Volunteer/VolunteerAvailabilityForm';
import PublicVolunteerRegistrationForm from './pages/Public/Volunteer/PublicVolunteerRegistrationForm';
import OutreachDistribution from './pages/Campaigns/VolunteerManagement/OutreachDistribution';
import OutreachEmailWizard from './pages/Campaigns/VolunteerManagement/OutreachEmailWizard';
import OutreachSmsWizard from './pages/Campaigns/VolunteerManagement/OutreachSmsWizard';
import EventCalendarView from './pages/Campaigns/VolunteerManagement/EventCalendarView';
import PublicEventCalendar from './pages/Public/Volunteer/PublicEventCalendar';
import EventTraining from './pages/Campaigns/VolunteerManagement/EventTraining';

// Event Post Management
import EventPostManagement from './pages/Campaigns/EventPost/EventPostManagement';
import EventPostEditor from './pages/Campaigns/EventPost/EventPostEditor';
import EventPostCategories from './pages/Campaigns/EventPost/EventPostCategories';
import EventPostAPIHelp from './pages/Campaigns/EventPost/EventPostAPIHelp';
import PublicEventPostList from './pages/Public/EventPost/PublicEventPostList';
import PublicEventPostDetail from './pages/Public/EventPost/PublicEventPostDetail';

import ListConsentedContacts from './pages/ConsentedContacts/ListConsentedContacts'
import TwitterConnector from './pages/Connector/Twitter/TwitterConnector';

// LMS
import LMSDashboard from './pages/LMS/LMSDashboard';
import CourseBuilder from './pages/LMS/CourseBuilder';
import CourseEnrollments from './pages/LMS/Courses/CourseEnrollments';
import CoursePreview from './pages/LMS/Courses/CoursePreview';
import StudentList from './pages/LMS/Students/StudentList';
import StudentDetail from './pages/LMS/Students/StudentDetail';
import StudentEnrollments from './pages/LMS/Students/StudentEnrollments';
import StudentImport from './pages/LMS/Students/StudentImport';
import EnrollmentList from './pages/LMS/Enrollments/EnrollmentList';
import EnrollmentProgress from './pages/LMS/Enrollments/EnrollmentProgress';
import LMSAnalytics from './pages/LMS/Analytics/LMSAnalytics';
import CourseAnalytics from './pages/LMS/Analytics/CourseAnalytics';
import TestBuilder from './pages/LMS/Tests/TestBuilder';
import TestResults from './pages/LMS/Tests/TestResults';
import PointsConfig from './pages/LMS/Gamification/PointsConfig';
import BadgeManagement from './pages/LMS/Gamification/BadgeManagement';
import Leaderboard from './pages/LMS/Gamification/Leaderboard';
import CourseInvitations from './pages/LMS/Invitations/CourseInvitations';
import LMSEmbedPages from './pages/LMS/LMSEmbedPages';

// CRM Imports
import CRMDashboard from './pages/CRM/Core/CRMDashboard';
import ContactsList from './pages/CRM/Core/ContactsList';
import ContactDetail from './pages/CRM/Core/ContactDetail';
import AccountsList from './pages/CRM/Core/AccountsList';
import AccountDetail from './pages/CRM/Core/AccountDetail';
import LeadsList from './pages/CRM/Core/LeadsList';
import LeadDetail from './pages/CRM/Core/LeadDetail';
import PublicLeadForm from './pages/Public/CRM/PublicLeadForm';
import TagsList from './pages/CRM/Core/TagsList';

// CRM SFA Imports
import SFADashboard from './pages/CRM/SFA/SFADashboard';
import OpportunityList from './pages/CRM/SFA/OpportunityList';
import OpportunityDetail from './pages/CRM/SFA/OpportunityDetail';
import OpportunityForm from './pages/CRM/SFA/OpportunityForm';
import OpportunityPipeline from './pages/CRM/SFA/OpportunityPipeline';
import ForecastDashboard from './pages/CRM/SFA/ForecastDashboard';
import ProductList from './pages/CRM/SFA/ProductList';
import CategoryManagement from './pages/CRM/SFA/CategoryManagement';
import PriceBookList from './pages/CRM/SFA/PriceBookList';
import QuoteList from './pages/CRM/SFA/QuoteList';
import QuoteBuilder from './pages/CRM/SFA/QuoteBuilder';
import QuoteDetail from './pages/CRM/SFA/QuoteDetail';
import SalesTargets from './pages/CRM/SFA/SalesTargets';
import SalesTeams from './pages/CRM/SFA/SalesTeams';
import TerritoryManagement from './pages/CRM/SFA/TerritoryManagement';
import LostReasonAnalytics from './pages/CRM/SFA/LostReasonAnalytics';
import LMSEmbedViewer from './pages/LMS/LMSEmbedViewer.js';

// CRM Help Desk Imports
import HelpDeskDashboard from './pages/CRM/HelpDesk/HelpDeskDashboard';
import TicketList from './pages/CRM/HelpDesk/TicketList';
import TicketDetail from './pages/CRM/HelpDesk/TicketDetail';
import TicketCategoryList from './pages/CRM/HelpDesk/TicketCategoryList';
import SLAPolicyList from './pages/CRM/HelpDesk/SLAPolicyList';
import KnowledgeBase from './pages/CRM/HelpDesk/KnowledgeBase';

function App() {
    const isLoggedIn = localStorage.getItem('user');
    const [isCollapsed, setIsCollapsed] = useState(false);

    const handleToggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // --- Route Protector ---
    const ProtectedRoute = ({ children }) => {
        const { activeChatbot } = useChatbots();
        if (!activeChatbot || !activeChatbot.is_process_completed) {
            const redirectPath = activeChatbot
                ? `/chatbot/create`
                : '/chatbots';
            return <Navigate to={redirectPath} replace />;
        }
        return children;
    };


    return (
        <Routes>
            {/* Routes outside Layout (Publicly Accessible) */}
            <Route path="/SignUp-Process-Steps" element={<SignUpSteps />} />
            <Route path="/Login" element={<SignIn />} />
            <Route path="/linkedin-callback" element={<LinkedInCallback />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/log-out" element={<LogoutPage />} />
            <Route path="/live" element={<LiveChatbot />} />
            <Route path="/verify/:token" element={<VerifiedEmail />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/pay/:payToken" element={<PublicPaymentPage />} />
            <Route path="/pay/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/pay/payment-cancel" element={<PaymentCancelPage />} />
            <Route path="/volunteer/availability/:token" element={<PublicAvailabilityForm />} />
            <Route path="/volunteer/register/:chatbotId" element={<PublicVolunteerRegistrationForm />} />
            <Route path="/events/calendar/:chatbotId" element={<PublicEventCalendar />} />
            <Route path="/posts/:chatbotId" element={<PublicEventPostList />} />
            <Route path="/posts/:chatbotId/:slug" element={<PublicEventPostDetail />} />
            <Route path="/lead-form/:formUuid" element={<PublicLeadForm />} />

            {/* Public Survey Form */}
            <Route path="/s/:surveyUuid" element={<PublicSurveyForm />} />

            <Route path="/lms/course/embbed/:token" element={<LMSEmbedViewer />} />
            {/* --- Authenticated Routes --- */}
            {isLoggedIn ? (
                <Route path="/" element={<Layout isCollapsed={isCollapsed} onToggleSidebar={handleToggleSidebar} />}>
                    
                    {/* 1. STANDALONE ROUTES: Wrapped by Layout, but NOT ChatbotLayout */}
                    <Route index element={<Navigate to="/chatbots" replace />} />
                    <Route path="chatbots" element={<MyChatbots />} />
                    <Route path="chatbot/create" element={<ChatbotCreationSteps />} />
                    <Route path="user-profile" element={<UserProfile />} />
                    <Route path="exception-log" element={<ListExceptionLog />} />
                    {/* <Route path="Link-accounts" element={<LinkedAccounts />} /> */}
                    <Route path="Test" element={<Test />} />
                    <Route path="help" element={<Help />} />
                    <Route path="support" element={<Support />} />
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="terms" element={<Terms />} />
                    <Route path="Billing" element={<Billing />} />
                    <Route path="Billing/Billing-History" element={<InvoiceHistory />} />
                    <Route path="Billing/Pricing" element={<Pricing />} />
                    <Route path="Billing/Subscription" element={<SubscriptionHistory />} />
                    <Route path="payment-success" element={<PaymentSuccess />} />

              
                    {/* --- User --- */}   
                    <Route path="user-management/users" element={<ManageUsers />} />
                    <Route path="user-management/roles" element={<ManageRoles />} />
                    
                    {/* 2. NESTED ROUTES: Wrapped by Layout AND ChatbotLayout */}
                    <Route path="/chatbot/:chatbotId/*" element={<ChatbotLayout />}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="wordpress-plugin" element={<WordpressPlugin />} />
                        <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                            
                        <Route path="exception-log" element={<ListExceptionLog />} />
                        <Route path="wordpress-plugin" element={<WordpressPlugin />} />

                        {/* --- Configuration --- */}
                        <Route path="configuration" element={<ProtectedRoute><WebsiteConfigurations /></ProtectedRoute>} />
                        <Route path="sitemap" element={<ProtectedRoute><AddSitemap /></ProtectedRoute>} />
                        <Route path="avatar" element={<ProtectedRoute><AvatarSettings /></ProtectedRoute>} />
                        <Route path="audio-language" element={<ProtectedRoute><ListAudioLanguage /></ProtectedRoute>} />
                        <Route path="chatbot-settings" element={<ProtectedRoute><ChatbotSettings /></ProtectedRoute>} />
                        <Route path="live-conversation" element={<ProtectedRoute><LiveConversation /></ProtectedRoute>} />
                        <Route path="choose-position" element={<ProtectedRoute><ChoosePosition /></ProtectedRoute>} />
                        <Route path="thumbnail-color" element={<ProtectedRoute><ColorSettings /></ProtectedRoute>} />
                        <Route path="suggested-questions" element={<ProtectedRoute><SuggestedQuestionsSettings /></ProtectedRoute>} />
                        <Route path="proactive-messages" element={<ProtectedRoute><ProactiveMessagesSettings /></ProtectedRoute>} />
                        
                        {/* --- Data Sources --- */}
                        <Route path="website" element={<ProtectedRoute><Scraper /></ProtectedRoute>} />
                        <Route path="documents" element={<ProtectedRoute><AddDocuments /></ProtectedRoute>} />
                        <Route path="images" element={<ProtectedRoute><AddImage /></ProtectedRoute>} />
                        <Route path="voices" element={<ProtectedRoute><VoiceTranscription /></ProtectedRoute>} />
                        <Route path="knowledge" element={<ProtectedRoute><KnowledgeData /></ProtectedRoute>} />

                        {/* --- Integrations --- */}
                        <Route path="channels" element={<ProtectedRoute><Channels /></ProtectedRoute>} />
                        <Route path="channels/whatsapp" element={<ProtectedRoute><WhatsappChannel /></ProtectedRoute>} />
                        <Route path="channels/whatsapp-bulk" element={<ProtectedRoute><BulkWhatsappSenderChannel /></ProtectedRoute>} />
                        <Route path="channels/sms" element={<ProtectedRoute><SmsBotConnector /></ProtectedRoute>} />

                         {/* // Connectors */}
                        <Route path="connectors" element={<ProtectedRoute><Connectors /></ProtectedRoute>} />
                        <Route path="connectors/gdrive" element={<ProtectedRoute><GoogleDriveConnector /></ProtectedRoute>} />
                        <Route path="connectors/onedrive" element={<ProtectedRoute><OneDriveConnector /></ProtectedRoute>} />
                        <Route path="connectors/salesforce" element={<SalesforceConnector />} />
                        <Route path="connectors/instagram" element={<InstagramConnector />} />
                        <Route path="connectors/servicenow" element={<ServiceNowConnector />} />
                        <Route path="connectors/twitter" element={<TwitterConnector />} />
                        <Route path="connectors/lms" element={<LMSDashboard />} />
                        <Route path="connectors/prayer-timing" element={<ProtectedRoute><PrayerTimingConnector /></ProtectedRoute>} />

                        {/* --- CRM Routes --- */}
                        <Route path="crm" element={<ProtectedRoute><CRMDashboard /></ProtectedRoute>} />
                        <Route path="crm-dashboard" element={<ProtectedRoute><CRMDashboard /></ProtectedRoute>} />
                        <Route path="crm/contacts" element={<ProtectedRoute><ContactsList /></ProtectedRoute>} />
                        <Route path="crm/contacts/:contactId" element={<ProtectedRoute><ContactDetail /></ProtectedRoute>} />
                        <Route path="crm/accounts" element={<ProtectedRoute><AccountsList /></ProtectedRoute>} />
                        <Route path="crm/accounts/:accountId" element={<ProtectedRoute><AccountDetail /></ProtectedRoute>} />
                        <Route path="crm/leads" element={<ProtectedRoute><LeadsList /></ProtectedRoute>} />
                        <Route path="crm/leads/:leadId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
                        <Route path="crm/tags" element={<ProtectedRoute><TagsList /></ProtectedRoute>} />

                        {/* CRM SFA Routes */}
                        <Route path="sfa-dashboard" element={<ProtectedRoute><SFADashboard /></ProtectedRoute>} />
                        <Route path="crm/opportunities" element={<ProtectedRoute><OpportunityList /></ProtectedRoute>} />
                        <Route path="crm/opportunities/new" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
                        <Route path="crm/opportunities/pipeline" element={<ProtectedRoute><OpportunityPipeline /></ProtectedRoute>} />
                        <Route path="crm/opportunities/:opportunityId" element={<ProtectedRoute><OpportunityDetail /></ProtectedRoute>} />
                        <Route path="crm/opportunities/:opportunityId/edit" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
                        
                        <Route path="crm/forecast" element={<ProtectedRoute><ForecastDashboard /></ProtectedRoute>} />
                        <Route path="crm/products" element={<ProtectedRoute><ProductList /></ProtectedRoute>} />
                        <Route path="crm/categories" element={<ProtectedRoute><CategoryManagement /></ProtectedRoute>} />
                        <Route path="crm/price-books" element={<ProtectedRoute><PriceBookList /></ProtectedRoute>} />
                        
                        <Route path="crm/quotes" element={<ProtectedRoute><QuoteList /></ProtectedRoute>} />
                        <Route path="crm/quotes/new" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
                        <Route path="crm/quotes/:quoteId" element={<ProtectedRoute><QuoteDetail /></ProtectedRoute>} />
                        <Route path="crm/quotes/:quoteId/edit" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
                        
                        <Route path="crm/targets" element={<ProtectedRoute><SalesTargets /></ProtectedRoute>} />
                        <Route path="crm/teams" element={<ProtectedRoute><SalesTeams /></ProtectedRoute>} />
                        <Route path="crm/territories" element={<ProtectedRoute><TerritoryManagement /></ProtectedRoute>} />
                        <Route path="crm/analytics/lost-reasons" element={<ProtectedRoute><LostReasonAnalytics /></ProtectedRoute>} />

                        {/* CRM Help Desk Routes */}
                        <Route path="crm/helpdesk" element={<ProtectedRoute><HelpDeskDashboard /></ProtectedRoute>} />
                        <Route path="helpdesk" element={<ProtectedRoute><HelpDeskDashboard /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/tickets" element={<ProtectedRoute><TicketList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/tickets/:ticketId" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/ticket-categories" element={<ProtectedRoute><TicketCategoryList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/sla-policies" element={<ProtectedRoute><SLAPolicyList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/knowledge-base" element={<ProtectedRoute><KnowledgeBase /></ProtectedRoute>} />

                        <Route path="agents" element={<ProtectedRoute><Agents /></ProtectedRoute>} />
                        <Route path="agents/google-calendar" element={<ProtectedRoute><GoogleCalendarAgents /></ProtectedRoute>} />
                        <Route path="agents/mysql" element={<ProtectedRoute><MySqlAgents /></ProtectedRoute>} />
                        <Route path="agents/gmail-email" element={<ProtectedRoute><GmailEmailAgent /></ProtectedRoute>} />
                        <Route path="agents/outlook-email" element={<ProtectedRoute><OutlookEmailAgent /></ProtectedRoute>} />
                        <Route path="agents/workflows" element={<ProtectedRoute><WorkflowList /></ProtectedRoute>} />
                        <Route path="agents/workflows/create" element={<ProtectedRoute><WorkflowCreate /></ProtectedRoute>} />
                        <Route path="agents/workflows/:workflowUid/edit" element={<ProtectedRoute><WorkflowCreate /></ProtectedRoute>} />
                        <Route path="agents/workflows/:workflowUid/runs" element={<ProtectedRoute><WorkflowRunDashboard /></ProtectedRoute>} />

                       
                        {/* --- Marketing --- */}
                        <Route path="campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
                        <Route path="campaigns/Gmail" element={<ProtectedRoute><GmailConnector /></ProtectedRoute>} />
                        <Route path="campaigns/Outlook" element={<OutlookConnector />} />
                        <Route path="campaigns/Sms" element={<SmsManagement />} />
                        <Route path="campaigns/Lead" element={<LeadConnector />} />

                        {/* --- SurveyGenie Routes --- */}
                        <Route path="surveys" element={<SurveyDashboard />} />
                        <Route path="surveys/builder/:surveyId" element={<SurveyBuilder />} />
                        <Route path="surveys/responses/:surveyId" element={<SurveyResponses />} />
                        <Route path="surveys/analytics/:surveyId" element={<SurveyAnalytics />} />
                        <Route path="surveys/distribution/:surveyId" element={<SurveyDistribution />} />
                        <Route path="surveys/question-bank" element={<QuestionBank />} />
                        <Route path="surveys/panelists" element={<PanelistManagement />} />
                        <Route path="surveys/distribute/email/:surveyId" element={<SurveyEmailWizard />} />
                        <Route path="surveys/text-analysis/:surveyId" element={<SurveyTextAnalysis />} />
                        <Route path="surveys/cleaning/:surveyId" element={<DataCleaningDashboard />} />
                        <Route path="surveys/cleaning/rules/:surveyId" element={<CleaningRulesBuilder />} />
                        <Route path="surveys/distribute/sms/:surveyId" element={<SurveySmsWizard />} />
                        <Route path="surveys/documents/:surveyId" element={<SurveyDocuments />} />
                        <Route path="surveys/faqs/:surveyId" element={<SurveyFAQs />} />


                        <Route path="lms">
                            <Route index element={<LMSDashboard />} />

                            {/* Courses */}
                            <Route path="courses/:courseId">
                                <Route path="builder" element={<CourseBuilder />} />
                                <Route path="enrollments" element={<CourseEnrollments />} />
                                <Route path="preview" element={<CoursePreview />} />

                                {/* Tests */}
                                <Route path="modules/:moduleId/test-builder" element={<TestBuilder />} />
                            </Route>

                            {/* Students */}
                            <Route path="students">
                                <Route index element={<StudentList />} />
                                <Route path="import" element={<StudentImport />} />
                                <Route path=":studentId" element={<StudentDetail />} />
                                <Route path=":studentId/enrollments" element={<StudentEnrollments />} />

                            </Route>

                            <Route path="embed-pages">
                                <Route index element={<LMSEmbedPages />} />
                            </Route>

                            {/* Enrollments */}
                            <Route path="enrollments">
                                <Route index element={<EnrollmentList />} />
                                <Route path=":enrollmentId/progress" element={<EnrollmentProgress />} />

                            </Route>

                            {/* Analytics */}
                            <Route path="analytics">
                                <Route index element={<LMSAnalytics />} />
                                <Route path="courses/:courseId" element={<CourseAnalytics />} />
                            </Route>

                            {/* Test Results */}
                            <Route path="test-results/:moduleId" element={<TestResults />} />

                            {/* Gamification */}
                            <Route path="gamification">
                                <Route path="points" element={<PointsConfig />} />
                                <Route path="badges" element={<BadgeManagement />} />
                            </Route>

                            <Route path="leaderboard" element={<Leaderboard />} />

                            {/* Invitations */}
                            <Route path="invitations" element={<CourseInvitations />} />
                        </Route>

                        {/* --- Volunteer Management Routes --- */}
                        <Route path="campaigns/volunteers" element={<ProtectedRoute><VolunteerManagement /></ProtectedRoute>} />
                        <Route path="campaigns/events" element={<ProtectedRoute><EventManagement /></ProtectedRoute>} />
                        <Route path="campaigns/campaign/:eventId" element={<ProtectedRoute><OutreachCampaignWizard /></ProtectedRoute>} />
                        <Route path="campaigns/event-volunteers" element={<ProtectedRoute><EventVolunteers /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/:eventId" element={<ProtectedRoute><OutreachDistribution /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/email/:eventId" element={<ProtectedRoute><OutreachEmailWizard /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/sms/:eventId" element={<ProtectedRoute><OutreachSmsWizard /></ProtectedRoute>} />
                        <Route path="campaigns/events/calendar" element={<ProtectedRoute><EventCalendarView /></ProtectedRoute>} />
                        <Route path="campaigns/events/training" element={<ProtectedRoute><EventTraining /></ProtectedRoute>} />

                        {/* --- Event Post Management Routes --- */}
                        <Route path="campaigns/event-posts" element={<ProtectedRoute><EventPostManagement /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/new" element={<ProtectedRoute><EventPostEditor /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/:postId/edit" element={<ProtectedRoute><EventPostEditor /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/categories" element={<ProtectedRoute><EventPostCategories /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/api-help" element={<ProtectedRoute><EventPostAPIHelp /></ProtectedRoute>} />

                        <Route path="advertisements" element={<ProtectedRoute><ListMonetize /></ProtectedRoute>} />
                        <Route path="marketplace-settings" element={<ProtectedRoute><MarketplaceSettings /></ProtectedRoute>} />
                        <Route path="consented-contacts" element={<ListConsentedContacts />} />
                    
                        {/* --- Tracking --- */}
                        <Route path="chat-history" element={<ProtectedRoute><ChatHistory /></ProtectedRoute>} />
                        <Route path="feedbacks" element={<ProtectedRoute><ListUserFeedback /></ProtectedRoute>} />
                        <Route path="analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                        
                        {/* --- Improvements & Settings --- */}
                        <Route path="question-improvements" element={<ProtectedRoute><ImproveQuestions /></ProtectedRoute>} />
                        <Route path="answers-improvements" element={<ProtectedRoute><ImproveAnswer /></ProtectedRoute>} />
                        <Route path="pronouns" element={<ProtectedRoute><Pronoun /></ProtectedRoute>} />
                        <Route path="summarization-settings" element={<ProtectedRoute><SummarizationSettings /></ProtectedRoute>} />
                        <Route path="term-and-use" element={<ProtectedRoute><TermsManagement /></ProtectedRoute>} />

                        


                        <Route path="payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
                    
                    </Route>

                    {/* Fallback for any unmatched authenticated route */}
                    <Route path="*" element={<Navigate to="/chatbots" replace />} />
                </Route>
            ) : (
                <Route path="*" element={<Navigate to="/Login" replace />} />
            )}
        </Routes>
    );
}

export default App;